export const nameToURLFormat = (name: string): string =>
  name
    .toLowerCase()
    .replace('-', ' ')
    .replace(/[^a-z\s+]/g, '')
    .replace(/\s+/g, '-')